/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTextValueListDto
 */
export interface CreateTextValueListDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTextValueListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTextValueListDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTextValueListDto
     */
    setupParameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTextValueListDto
     */
    groupId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTextValueListDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTextValueListDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTextValueListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTextValueListDto
     */
    values?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTextValueListDto
     */
    $type?: CreateTextValueListDtoTypeEnum;
}


/**
 * @export
 */
export const CreateTextValueListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateTextValueListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateTextValueListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateTextValueListDtoTypeEnum = typeof CreateTextValueListDtoTypeEnum[keyof typeof CreateTextValueListDtoTypeEnum];



/**
 * Check if a given object implements the CreateTextValueListDto interface.
 */
export function instanceOfCreateTextValueListDto(value?: unknown): value is CreateTextValueListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateTextValueListDtoTypeEnum)[0];
}

export function CreateTextValueListDtoFromJSON(json: any): CreateTextValueListDto {
    return CreateTextValueListDtoFromJSONTyped(json, false);
}

export function CreateTextValueListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTextValueListDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'setupParameterId': json['setupParameterId'] == null ? undefined : json['setupParameterId'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isReadonly': json['isReadonly'] == null ? undefined : json['isReadonly'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'values': json['values'] == null ? undefined : json['values'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateTextValueListDtoToJSON(value?: CreateTextValueListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'setupParameterId': value['setupParameterId'],
        'groupId': value['groupId'],
        'isRequired': value['isRequired'],
        'isReadonly': value['isReadonly'],
        'isEnabled': value['isEnabled'],
        'values': value['values'],
        '$type': value['$type'],
    });
}

